import { Item } from "@aitisal/contracts/restaurant/menu";
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface WishlistState {
  wishlist: Item[];
  addToWishlist: (item: Item) => void;
  removeFromWishlist: (itemId: string) => void;
  clearWishlist: () => void;
}

export const useWishlistStore = create<WishlistState>()(
  persist(
    (set) => ({
      wishlist: [],
      addToWishlist: (item) =>
        set((state) => ({
          // Creates a new array reference to trigger instant React re-render
          wishlist: state.wishlist.some((i) => i.itemId === item.itemId)
            ? state.wishlist
            : [...state.wishlist, item],
        })),
      removeFromWishlist: (itemId) =>
        set((state) => ({
          wishlist: state.wishlist.filter((i) => i.itemId !== itemId),
        })),
      clearWishlist: () =>
        set({ wishlist: [] }),
    }),
    { name: 'wishlist-storage' }
  )
);
